<template>
  <div id="app" v-show="isInitTheme">
    <router-view></router-view>
  </div>

</template>

<script>
// import AppHeader from './Header.vue'
// import AppFooter from './Footer.vue'

export default {
  name: 'AppLayout',
  // components: {
  //   AppHeader,
  //   AppFooter
  // },
  computed: {
    isInitTheme () {
      return this.$store.getters['theme/isInitTheme']
    }
  }
}
</script>
